import React, { useState, useEffect } from "react";
import { motion, useScroll } from "framer-motion";
import Navbar from "../Components/landing/Navbar";
import Hero from "../Components/landing/Hero";
import About from "../Components/landing/About";
import Services from "../Components/landing/Services";
import HowItWorks from "../Components/landing/HowItWorks";
import AppDownload from "../Components/landing/AppDownload";
import ContactUs from "../Components/landing/ContactUs";
// import Testimonials from "../Components/landing/Testimonials";

import FloatingActionButton from "../Components/landing/FloatingActionButton";
import Button from "../Components/ui/Button";

export default function Home() {
  const { scrollYProgress } = useScroll();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FA] overflow-x-hidden">
      <Navbar />
      
      <main>
        <Hero />
        <About />
        <Services />
        <HowItWorks />
        <AppDownload />
        <ContactUs />
        {/* <Testimonials /> */}

        {/* Example Button Usage
        <div
          style={{
            textAlign: "center",
            marginTop: "5px",     // 🔼 moved slightly upwards
            marginBottom: "40px",
          }}
        >
        </div> */}
      </main>

     
      <FloatingActionButton />

      {/* Progress Indicator */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#E63946] to-[#FFC300] z-50 origin-left"
        style={{ scaleX: scrollYProgress }}
      />
    </div>
  );
}
